export const PODCASTIFY_STORAGE_BUCKET = "podcastify_storage";
export const PODCASTIFY_DEMO_BUCKET = "podcastify_storage_public_for_demo";

/**
 * Shared demo objects that were migrated out of the main storage bucket into
 * the public demo bucket (see `backend/podcastfy/services/storage_cleanup.py`
 * and `frontend/lib/demo/{welcome-podcast,study-demos}.ts`). Any URL built for
 * these paths must resolve against the demo bucket, otherwise audio/transcript
 * lookups return 404 after the migration.
 */
const DEMO_BUCKET_PATHS: ReadonlySet<string> = new Set([
  "demo/welcome.mp3",
  "173/podcast_a79c9acf69bb44c7b1938ae7ccf89fba.mp3",
  "173/transcript_8e0dc7b10c4442d4a5b3bb577006c048.json",
  "210/podcast_bfb0c4d7e8f3449ea317af17026e255c.mp3",
]);

/**
 * The bucket holding a given storage path. Demo/shared objects live in the
 * public demo bucket; everything else stays in the main Podcastify bucket.
 */
export function storageBucketForPath(path: string): string {
  return DEMO_BUCKET_PATHS.has(path)
    ? PODCASTIFY_DEMO_BUCKET
    : PODCASTIFY_STORAGE_BUCKET;
}

/**
 * Build a public GCS URL for an object inside a public bucket.
 * Mirrors the previous Supabase `storage.from(bucket).getPublicUrl(path)`.
 */
export function buildGcsUrl(bucket: string, path: string): string {
  return `https://storage.googleapis.com/${bucket}/${path}`;
}

/**
 * Resolve a storage path to its public URL against the correct bucket.
 */
export function buildStorageUrl(path: string): string {
  return buildGcsUrl(storageBucketForPath(path), path);
}